import { ChatSummary } from '../models/Chat';
import { chatParticipants } from './chat';

export type ChatAvatarMap = ReadonlyMap<string, string | undefined>;

export function buildChatAvatarMap(
  summaries: readonly ChatSummary[],
  currentUserId?: string,
  currentProfileImageUrl?: string | null
): Map<string, string | undefined> {
  const map = new Map<string, string | undefined>();

  for (const summary of summaries) {
    for (const participant of chatParticipants(summary)) {
      const url = participant.profileImageUrl?.trim();
      if (url) map.set(participant.userId, url);
    }

    // Legacy one/two fields in case participants omitted profile URLs
    const oneUrl = summary.participantOneProfileImageUrl?.trim();
    const twoUrl = summary.participantTwoProfileImageUrl?.trim();
    if (oneUrl && summary.participantOneUserId) {
      map.set(summary.participantOneUserId, oneUrl);
    }
    if (twoUrl && summary.participantTwoUserId) {
      map.set(summary.participantTwoUserId, twoUrl);
    }
  }

  if (currentUserId) {
    const own = currentProfileImageUrl?.trim();
    if (own) map.set(currentUserId, own);
  }

  return map;
}

export function chatAvatarSrc(
  map: ChatAvatarMap,
  userId: string | null | undefined
): string | undefined {
  if (!userId) return undefined;
  return map.get(userId)?.trim() || undefined;
}
